import { REFI_WEB_UI_CONST } from '../../constants/constants.js';
import SessionService from '../session/session.service.js';
import { StorageService } from '../storage/storage.service.js';
import { AppService } from '../app/app.service.js';
import { DebugService } from '../debug/debug.service.js';

class _ApiService {
  constructor() {
    this.headers = REFI_WEB_UI_CONST.HTTP_HEADERS;
    if (SessionService.clientCorrelationId) {
      this.headers[REFI_WEB_UI_CONST.CLIENT_CORRELATION_ID_HEADER] = SessionService.clientCorrelationId;
    } else {
      SessionService.clientCorrelationId = this.headers[REFI_WEB_UI_CONST.CLIENT_CORRELATION_ID_HEADER];
    }
    if (REFI_WEB_UI_CONST.isDevEnv()) {
      this.headers['x-upstream-env'] = 'dev';
    } else if (REFI_WEB_UI_CONST.isSBEnv()) {
      this.headers['x-upstream-env'] = 'sb';
    } else if (REFI_WEB_UI_CONST.isPerfEnv()) {
      this.headers['x-upstream-env'] = 'perf';
    }
    this.debug = new DebugService('API_SERVICE');
    this.logout = this.logout.bind(this);
    this.shapeErrors = 0;
  }

  async persistMarketingAttributes({ referralSource, externalId }) {
    const persistMarketingAttributesBody = {
      referralSource,
      externalId,
    };
    return this.post(REFI_WEB_UI_CONST.API.persistMarketingAttributes, persistMarketingAttributesBody, {});
  }

  async get(url, opts) {
    this.buildHeaders();
    this.debug.log(`Calling ${url} with ${JSON.stringify(this.headers)}`);
    return fetch(url, {
      headers: this.headers,
      withCredentials: true,
      ...opts,
    }).then(res => this.httpInterceptor(res));
  }

  async post(url, body, opts = {}) {
    this.buildHeaders();
    const options = {
      ...opts,
      headers: this.headers,
      withCredentials: true,
      method: 'POST',
    };
    if (body !== undefined) {
      options.body = body ? JSON.stringify(body) : '{}';
    }
    this.debug.log(`Calling ${url} with ${JSON.stringify(options)}`);
    return fetch(url, options).then(res => this.httpInterceptor(res));
  }

  async put(url, body = {}, opts = {}) {
    this.buildHeaders();
    const options = {
      ...opts,
      headers: this.headers,
      withCredentials: true,
      method: 'PUT',
      body: JSON.stringify(body),
    };
    return fetch(url, options).then(res => this.httpInterceptor(res));
  }

  buildHeaders() {
    const { appDetails } = SessionService.getAuthSession();
    if (appDetails) {
      this.headers[REFI_WEB_UI_CONST.EAPP_ID] = appDetails?.eAppId;
    }
    if (sessionStorage.getItem(REFI_WEB_UI_CONST.C1_REFI_APPIDS)) {
      this.headers[REFI_WEB_UI_CONST.C1_REFI_APPIDS] = sessionStorage.getItem(REFI_WEB_UI_CONST.C1_REFI_APPIDS);
    }
  }

  httpInterceptor(res) {
    this.debug.log('res: ', res);
    this.debug.log('status ', res.status);
    if (res.status === 506) {
      this.shapeErrors += 1;
    }

    if (res.headers && res.headers.has('C1-REFI-APPIDS')) {
      sessionStorage.setItem('C1-REFI-APPIDS', res.headers.get('C1-REFI-APPIDS'));
    }
    if (res.status === 204) {
      return res;
    }
    if (res.status >= 200 && res.status < 300) {
      const body = res.json();
      this.debug.log(body);
      return body;
    }
    return Promise.reject(res);
  }

  logout() {
    let timeOutURL = REFI_WEB_UI_CONST.timeOutUrl();
    timeOutURL += `?timeOut=y`;
    this.post(REFI_WEB_UI_CONST.LOGOUT_DXGW_URL)
      .catch(() => {
        // NOTE: The logout endpoint can fail if the user does not have a session
        // since the logout endpoint is not anonymous. In this case, cloudfront will return
        // the 404 html page which will throw an error when the httpInterceptor attempts to parse
        // it as json.
        this.debug.log('Logout failed');
      })
      .finally(() => {
        SessionService.clearSession();
        StorageService.clearStorage();
        AppService.setApplication(undefined);
        window.open(timeOutURL, '_self');
      });
  }
}

export const ApiService = new _ApiService();
